// @greenlight-spec: 15-database-schema.md
// @greenlight-spec: 17-code-organization.md
export const ORG_ROLES = ['org_admin', 'admin', 'user'];
/**
 * Where `users.role` comes from, recorded in `orgs.idp_config.role_source`
 * (docs/10 §IdP group → platform role mapping):
 * - `idp` — the IdP's groups are authoritative; roles are recomputed at login.
 * - `greenlight` — Greenlight owns roles; org_admins/admins assign them in-product.
 */
export const ROLE_SOURCES = ['idp', 'greenlight'];
/**
 * Where an org's group memberships come from (docs/41 §When groups are
 * Greenlight-managed). Derived from the IdP type, never configured, and
 * independent of `RoleSource`: an Entra org with Greenlight-managed *roles*
 * still has IdP-sourced *groups*.
 * - `idp` — the IdP delivers group claims at login (Entra, Okta).
 * - `greenlight` — the IdP resolves no memberships (Google at MVP), so groups
 *   are created and membered in Greenlight.
 */
export const GROUP_SOURCES = ['idp', 'greenlight'];
/**
 * Rank of each platform role for the Greenlight-managed assignment ceiling
 * (`org_admin` > `admin` > `user`, docs/10): a caller may set or modify only
 * roles whose rank is ≤ their own.
 */
export const ROLE_RANK = {
    org_admin: 3,
    admin: 2,
    user: 1,
};
//# sourceMappingURL=user.js.map